import React, { useState, useEffect } from 'react';
import WorkInProgress from '../../../components/common/WorkInProgress';
import ProfileBasicInfo from './ProfileBasicInfo';
import DashboardCharts from './DashboardCharts';
import CoursesComponent from './CoursesComponent';
import SalesComponent from './SalesComponent';
import './dashboard.css'
import { getMyProfileData } from '../../../services/Trainer/trainer';

const StaffProfile = () => {
  const [activeTab, setActiveTab] = useState('courses');

  const [userData,setUserData] = useState()
  const [loading , setLoading] = useState(false)

  const handleUpdateUser = () => {
   fetchData()
  };
    const fetchData = async () => {
      setLoading(true)
    const data = await getMyProfileData(); 
    if (data) {
      console.log("admin profile data >>>", data);
      setUserData(data);
    }
    setLoading(false)
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="admin-dashboard" style={{padding:'20px'}}>
      {
        loading ?
         <div className="col-md-12" style={{ height: '40vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </div>
        :
        <>
         <ProfileBasicInfo
        userData={userData}
        onUpdateUser={handleUpdateUser}
      />
      <DashboardCharts userData={userData}/>
     
      <div className='my-4'>
      <CoursesComponent />

      </div>
        </>
}
     
    </div>
  );
};

export default StaffProfile;